"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datePickerCellStyles = exports.datePickerButtonStyle = exports.datePickerDayOfWeekHeaderStyle = exports.datePickerBodyStyle = exports.datePickerHeaderStyle = exports.datePickerWidgetStyle = void 0;
var tslib_1 = require("tslib");
var PreventUserSelect_1 = require("../styles/PreventUserSelect");
var TabStyles_1 = require("../styles/TabStyles");
var Colors = TabStyles_1.TabStyles.Colors, Typography = TabStyles_1.TabStyles.Typography, Sizing = TabStyles_1.TabStyles.Sizing, Spacing = TabStyles_1.TabStyles.Spacing;
exports.datePickerWidgetStyle = tslib_1.__assign({ backgroundColor: 'white', borderColor: Colors.L5, borderRadius: Sizing.BorderRadius, borderStyle: 'solid', borderWidth: Sizing.BorderWidth, boxSizing: 'border-box', color: Typography.Color.Primary, display: 'inline-block', fontSize: Typography.Sizing.Default, lineHeight: 'normal', padding: Spacing.DefaultSpace }, PreventUserSelect_1.PreventUserSelect);
exports.datePickerHeaderStyle = {
    borderBottom: "1px solid " + Colors.F4,
    paddingBottom: Spacing.DefaultSpace,
};
exports.datePickerBodyStyle = {
    marginTop: Spacing.DefaultSpace,
    marginBottom: Spacing.DefaultSpace,
};
exports.datePickerDayOfWeekHeaderStyle = {
    marginTop: Spacing.DefaultSpace,
};
exports.datePickerButtonStyle = {
    marginBottom: Spacing.DefaultSpace,
};
var datePickerCellBaseStyle = {
    alignItems: 'center',
    borderRadius: 1,
    boxSizing: 'border-box',
    color: Typography.Color.Primary,
    display: 'inline-flex',
    height: '30px',
    justifyContent: 'center',
    width: '30px',
};
exports.datePickerCellStyles = {
    dayOfWeekColHeader: tslib_1.__assign(tslib_1.__assign({}, datePickerCellBaseStyle), { fontWeight: 'bold' }),
    default: tslib_1.__assign({}, datePickerCellBaseStyle),
    disabled: {
        textDecoration: 'line-through',
    },
    inOtherMonths: tslib_1.__assign(tslib_1.__assign({}, datePickerCellBaseStyle), { color: Typography.Color.Disabled }),
    isoWeekNum: tslib_1.__assign(tslib_1.__assign({}, datePickerCellBaseStyle), { fontWeight: 'bold', marginRight: Spacing.DefaultSpace }),
    isoWeekNumColHeader: tslib_1.__assign(tslib_1.__assign({}, datePickerCellBaseStyle), { fontWeight: 'bold', marginRight: Spacing.DefaultSpace }),
    selected: tslib_1.__assign(tslib_1.__assign({}, datePickerCellBaseStyle), { backgroundColor: Colors.F4 }),
    today: tslib_1.__assign(tslib_1.__assign({}, datePickerCellBaseStyle), { borderColor: Colors.GoLight, borderRadius: Sizing.BorderRadius, borderStyle: 'solid', borderWidth: Sizing.BorderWidth }),
    todaySelected: tslib_1.__assign(tslib_1.__assign({}, datePickerCellBaseStyle), { backgroundColor: Colors.F8, color: Colors.White }),
};
//# sourceMappingURL=DatePickerWidgetStyles.js.map